<mbs-modal
  #modal
  [isCustomModal]="true"
  [showFooter]="showFooter"
  [title]="'Cancel Account Deletion'">
  <div modal-body>
    @if (ubSubscribe.canRestoreTypes.includes(storageAccount.usageTypeByLifeCycle)) {
      Are you sure you want to cancel the delete operation?
    }

    @if (ubSubscribe.readonlyTypes.includes(storageAccount.usageTypeByLifeCycle)) {
      @if (storageAccount.usageTypeByLifeCycle === UnifiedBillingAccountType.TrialReadOnly) {
        Your trial {{ storageAccount.storageTypeDisplayName }} storage account will be restored in read-only mode. To continue using
        {{ storageAccount.storageTypeDisplayName }} storage with full access you need to
        <mbs-button
          [isCtrl]="true"
          (click)="handleSubscribe()"
          >subscribe.</mbs-button
        >
      }
      @if (storageAccount.usageTypeByLifeCycle === UnifiedBillingAccountType.PaidWithDebtReadOnly) {
        Your {{ storageAccount.storageTypeDisplayName }} storage will be restored in read-only mode. Full access cannot be restored until
        your subscription has been paid. <ng-container *ngTemplateOutlet="checkPaymentMethod"></ng-container>
      }
    }

    @if (ubSubscribe.deleteByOurSystemTypes.includes(storageAccount.usageType)) {
      @if (storageAccount.usageType === UnifiedBillingAccountType.TrialDeactivated) {
        Full access cannot be restored until you subscribe. Your data will be cleared in {{ durationDeleteDays }}. To continue using
        {{ storageAccount.storageTypeDisplayName }} Storage please
        <mbs-button
          [isCtrl]="true"
          (click)="handleSubscribe()"
          >subscribe.</mbs-button
        >
      }
      @if (storageAccount.usageType === UnifiedBillingAccountType.PaidWithDebtDeactivated) {
        Access cannot be restored until the subscription has been paid. Your data will be cleared in {{ durationDeleteDays }}.
        <ng-container *ngTemplateOutlet="checkPaymentMethod"> </ng-container>
      }
    }

    <ng-template #checkPaymentMethod>
      @if ('Licenses' | can: 'read') {
        Please check your
        @if (!(isPostPayment | async)) {
          <mbs-payment-method-button></mbs-payment-method-button>
        }
        @if (isPostPayment | async) {
          <mbs-button
            type="link"
            [isCtrl]="true"
            [size]="size.inherit"
            (click)="openPaymentDebtModal()"
            >payment method</mbs-button
          >
        }
        .
      } @else {
        <a [href]="'mailto:' + ubSubscribe.providerContactEmail">Contact the account owner.</a>
      }
    </ng-template>
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [loading]="loading"
      (click)="handleResolve()"
      >OK</mbs-button
    >
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()"
      >Close</mbs-button
    >
  </ng-container>
</mbs-modal>
